import React, { useEffect, useState } from 'react';
import { Grid, TextField, Button, IconButton, Typography, Box, CircularProgress, Autocomplete, FormControlLabel, Checkbox } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import axios from './../../axios/api';
import toast from 'react-hot-toast';
import { PREFIX_URL } from '../../components/Constants';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const FormCategories = ({ isEdit = false, IdEdit, DataEdit, refreshData, handleCloseModal }) => {
    const [Title, setTitle] = useState('');
    const [selectedImage, setSelectedImage] = useState(null);
    const [imageName, setImageName] = useState('');
    const [LoadingButton, setLoadingButton] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [Data, setData] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState({ id: 0, title: "-" });
    const [errors, setErrors] = useState({ img: '', parent_id: '', title: '' });
    const [IsShowHome, setIsShowHome] = useState(false);

    useEffect(() => {
        GetData();
        setErrors({
            parent_id: '',
            img: '',
            title: ''
        })
    }, []);

    useEffect(() => {
        if (isEdit) {
            console.log("Data" + JSON.stringify(DataEdit));
            setTitle(DataEdit?.title);

            if (DataEdit?.is_home) {
                setIsShowHome(DataEdit?.is_home);

            }
            if (DataEdit?.parent_id != 0 && DataEdit?.parent_id != null) {
                if (DataEdit?.parent) {
                    setSelectedCategory(DataEdit?.parent)
                }
            }
            if (DataEdit?.img) {
                setSelectedImage(checkAndAddPrefix(DataEdit?.img));
                setImageName("Edit");
            }
        }
    }, [isEdit])


    const checkAndAddPrefix = (url) => {
        const prefix = PREFIX_URL;
        if (url && url.startsWith('/uploads/')) {
            return `${prefix}${url}`;
        }
        return url;
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedImage(file);
            setImageName(file.name);
        }
        if (errors.img) {
            setErrors((prevErrors) => ({ ...prevErrors, img: '' }));
        }
    };
    const reseteState = () => {
        setImageName('');
        setTitle('');
        setSelectedCategory(null);
        setSelectedImage(null);
        setIsShowHome(false);
        setErrors({
            parent_id: '',
            img: '',
            title: ''
        })
    }


    const handleRemoveImage = () => {
        setSelectedImage(null);
        setImageName('');

    };



    const UpdateCategoriy = async () => {
        try {
            setLoadingButton(true);
            // Send the base64 string using axios
            const formData = new FormData();
            // Append the data to the FormData object
            formData.append('title', Title);
            formData.append('is_home', IsShowHome ? "1" : "0");

            if (selectedImage && imageName != "Edit") {
                formData.append('img', selectedImage);
            }
            if (selectedCategory && selectedCategory?.id != 0) {

                formData.append('parent_id', (selectedCategory?.id));
            }

            const res = await axios.post(`/admin/category/update/${IdEdit}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });

            toast.success(res.data?.message);
            refreshData();
            reseteState();
            handleCloseModal();
        } catch (error) {
            if (error.response?.status === 422) {
                setErrors({
                    title: error.response.data.data.title ? error.response.data.data.title[0] : '',
                    parent_id: error.response.data.data.parent_id ? error.response.data.data.parent_id[0] : '',
                    img: error.response.data.data.img ? error.response.data.data.img[0] : '',
                });
            } else {
                toast.error(error.response?.data?.message || 'An error occurred');
            }
        } finally {
            setLoadingButton(false);
        }
    };



    const sendCategoriy = async () => {
        try {
            const formData = new FormData();
            // Append the data to the FormData object
            formData.append('title', Title);
            formData.append('is_home', IsShowHome ? "1" : "0");

            if (selectedImage) {
                formData.append('img', selectedImage);
            }
            if (selectedCategory && selectedCategory?.id != 0) {

                formData.append('parent_id', (selectedCategory?.id));
            }

            setLoadingButton(true);

            // Send the base64 string using axios
            const res = await axios.post('/admin/category/store', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });

            toast.success(res.data?.message);
            reseteState();
            GetData();

        } catch (error) {
            if (error.response?.status === 422) {
                setErrors({
                    title: error.response.data.data.title ? error.response.data.data.title[0] : '',
                    parent_id: error.response.data.data.parent_id ? error.response.data.data.parent_id[0] : '',
                    img: error.response.data.data.img ? error.response.data.data.img[0] : '',
                });
            } else {
                toast.error(error.response?.data?.message || 'An error occurred');
            }
        } finally {
            setLoadingButton(false);
        }
    };

    const handleTitleChange = (event) => {
        setTitle(event.target.value);
        if (errors.title) {
            setErrors((prevErrors) => ({ ...prevErrors, title: '' }));
        }
    };

    const handleChangeShowHome = (event) => {
        setIsShowHome(event.target.checked);
    };

    const GetData = async () => {
        try {
            setIsLoading(true);
            let url = `/admin/category`;
            const res = await axios.get(url);
            const dataRecived = await res.data?.data;
            dataRecived.unshift({ id: 0, title: "-" });
            setData(dataRecived);
            setSelectedCategory(dataRecived[0]);

            if (isEdit && DataEdit?.parent_id) {
                const defaultCategory = dataRecived.find(item => item.id === DataEdit?.parent_id);
                setSelectedCategory(defaultCategory || null);
            }
            console.log(dataRecived);
        } catch (e) {
            console.log(e.response, "eeeeeeeee");
        } finally {
            setIsLoading(false);
        }
    };
    const isBlobOrFile = (obj) => {
        return obj instanceof Blob || obj instanceof File;
    };
    return (
        <div dir="rtl">
            <Grid container spacing={2}>
                {isLoading ? (
                    <Grid item xs={12} sx={{
                        display: 'flex',
                        justifyContent: 'center', alignItems: 'center', height: '10vh'
                    }}>
                        <CircularProgress />
                    </Grid>
                ) : (
                    <>
                        <Grid item lg={12} md={12} sm={12}>
                            <TextField
                                id="title"
                                label="عنوان"
                                type="text"
                                placeholder='دسته بندی جدید را وارد کنید'
                                variant="outlined"
                                fullWidth
                                value={Title}
                                onChange={handleTitleChange}
                                sx={{ textAlign: 'right' }}
                                error={Boolean(errors.title)}
                                helperText={errors.title}
                            />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12}>
                            <Autocomplete
                                options={Data}
                                value={selectedCategory}
                                getOptionLabel={(option) => option.title}
                                onChange={(event, newValue) => {
                                    setSelectedCategory(newValue ? newValue : null);
                                    if (errors.parent_id) {
                                        setErrors((prevErrors) => ({ ...prevErrors, parent_id: '' }));
                                    }

                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="انتخاب دسته بندی"
                                        variant="outlined"
                                        placeholder="دسته بندی را انتخاب کنید"
                                        fullWidth
                                        error={Boolean(errors.parent_id)}
                                        helperText={errors.parent_id}
                                    />
                                )}
                                ListboxProps={{ style: { direction: 'rtl', textAlign: 'right' } }} // Ensures the list is RTL
                            />
                        </Grid>
                        {selectedImage && (
                            <Grid item lg={12} md={12} sm={12}>
                                <Box sx={{
                                    position: 'relative',
                                    display: 'inline-block',
                                    border: '1px dashed #ccc',
                                    padding: 1,
                                    borderRadius: 2
                                }}>
                                    <img
                                        src={isBlobOrFile(selectedImage) ? URL.createObjectURL(selectedImage) : selectedImage}

                                        alt="Selected Image"
                                        style={{ width: 100, height: 100, borderRadius: 10 }}
                                    />
                                    <IconButton
                                        onClick={handleRemoveImage}
                                        aria-label="Remove Image"
                                        size="small"
                                        sx={{
                                            width: 20,
                                            height: 20,
                                            position: 'absolute',
                                            top: -5,
                                            right: -7,
                                            backgroundColor: '#EC2327',
                                            color: 'white',
                                            '&:hover': {
                                                opacity: 1,
                                            },
                                        }}
                                    >
                                        <CloseIcon sx={{ width: 10, height: 10 }} color="black" fontSize="small" />
                                    </IconButton>
                                    <br />
                                    <Typography variant="caption" sx={{ mt: 1 }}>
                                        {imageName}
                                    </Typography>
                                </Box>
                            </Grid>
                        )}
                        <Grid item lg={12} md={12} sm={12}>
                            <Button
                                component="label"
                                role={undefined}
                                variant="contained"
                                tabIndex={-1}
                                startIcon={<CloudUploadIcon />}
                            >
                                <Typography variant="caption">آپلود تصویر</Typography>
                                <VisuallyHiddenInput type="file" accept="image/*" onChange={handleImageChange} />
                            </Button>
                            {errors.img && (
                                <Typography color="error" variant="caption" sx={{ mt: 1 }}>
                                    {errors.img}
                                </Typography>
                            )}
                        </Grid>
                        <Grid item lg={12} md={12} sm={12}>

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={IsShowHome}
                                        onChange={handleChangeShowHome}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                }
                                label={<Typography variant="h6">نمایش دسته بندی در صفحه اول موبایل</Typography>}
                            />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12}>
                            {isEdit ?
                                <Button
                                    onClick={UpdateCategoriy}
                                    disabled={LoadingButton}
                                    color="secondary"
                                    fullWidth variant="contained"
                                    size="large">
                                    {LoadingButton && <CircularProgress size={24} color="inherit" />}

                                    <Typography color="white">ویرایش دسته بندی</Typography>
                                </Button>
                                :
                                <Button
                                    color="secondary"
                                    fullWidth
                                    variant="contained"
                                    size="large"
                                    onClick={sendCategoriy}
                                    disabled={LoadingButton}
                                >
                                    {LoadingButton && <CircularProgress size={24} color="inherit" />}

                                    <Typography color="white">ثبت دسته بندی جدید</Typography>
                                </Button>
                            }
                        </Grid>
                    </>
                )}
            </Grid>
        </div>
    );
};

export default FormCategories;
